import {ReadUser, UpdateLocalizationPreferences} from '@tinct/core-api-models';
import {Button, Card, CardContent, CardFooter, CardHeader, CardTitle} from '@tinct/web-components';
import {FormProvider} from 'react-hook-form';
import {createConnectedInputHelpers} from '@tinct/web-form';
import {useUpdateLocalizationPreferencesForm} from '../hooks/use-update-localization-preferences-form';

type UpdateLocalizationPreferencesSectionProps = {
  user: ReadUser;
};

const DATE_FORMAT_OPTIONS = [
  {value: 'DD/MM/YYYY', label: '21/12/2025'},
  {value: 'MM/DD/YYYY', label: '12/21/2025'},
];

const LANGUAGE_OPTIONS = [
  {iso2: 'en', label: 'English', flag: '🇬🇧'},
  {iso2: 'fr', label: 'French', flag: '🇫🇷'},
  {iso2: 'es', label: 'Spanish', flag: '🇪🇸'},
  {iso2: 'de', label: 'German', flag: '🇩🇪'},
];

const {ControlledLanguageInput, ControlledRadioGroupInput} =
  createConnectedInputHelpers<UpdateLocalizationPreferences>();

export const UpdateLocalizationPreferencesSection = ({
  user,
}: UpdateLocalizationPreferencesSectionProps) => {
  const {form, handleSubmit} = useUpdateLocalizationPreferencesForm(user);

  return (
    <FormProvider {...form}>
      <form id="update-localization-preferences-form" onSubmit={handleSubmit}>
        <Card className="rounded-2xl">
          <CardHeader>
            <CardTitle className="font-heading text-xl tracking-[-0.3px]">
              Display preferences
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-2">
            <div className="flex flex-col">
              <ControlledLanguageInput
                name="localizationPreferences.language"
                label="Language"
                languages={LANGUAGE_OPTIONS}
                direction="horizontal"
                className="py-6"
              />
              <ControlledRadioGroupInput
                name="localizationPreferences.dateFormat"
                label="Date format"
                options={DATE_FORMAT_OPTIONS}
                direction="horizontal"
                className="py-6"
              />
            </div>
          </CardContent>
          <CardFooter className="justify-end border-t">
            <Button type="submit" form="update-localization-preferences-form">
              Save
            </Button>
          </CardFooter>
        </Card>
      </form>
    </FormProvider>
  );
};
